import {BaseAppProps, BaseAppState} from "shared/BaseApp";
import React, {ReactElement} from 'react';
import {Main} from "./Main";
import {PathComponent} from "../index";
import {AppPrefs} from "./app_prefs";
import {BaseAppPrefs} from "../shared/BaseAppPrefs";
import {FyneAIApp} from "../fyneai-shared/FyneAIApp";
import {ResourceAccessRole} from "../fyneai-shared/types";

export type AppProps = BaseAppProps & {}

type AppState = BaseAppState & {}

export class App extends FyneAIApp<AppProps, AppState> {

  static nestedPaths(): PathComponent[] {
    return Main.nestedPaths();
  }

  getAppPrefs<T extends BaseAppPrefs>(): T {
    //@ts-ignore
    return AppPrefs.getInstance() as T;
  }

  getPreferredColorScheme(): "light" | "dark" | null | undefined {
    return "dark";
  }

  protected getSignupEnabled(): boolean {
    return true;
  }

  protected getResourceAccessRole(): ResourceAccessRole | undefined {
    return ResourceAccessRole.LABELER;
  }

  protected getAppName(): string {
    return "Labeler";
  }

  protected renderFyneAIMain(): ReactElement {
    return <Main path={this.props.path}/>;
  }
}
